module.exports = __webpack_public_path__ + "img/CCLF_infographic-14.a74735bc.png";